var $6e590bf3b0839840$exports = {};
document.addEventListener('DOMContentLoaded', async ()=>{
    const overlay = document.getElementById('overlay');
    let activeTooltip = null; // Track the currently active tooltip
    let originalParents = new Map(); // Store original parents of tooltips
    // Debounce utility function
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = ()=>{
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    // Optimized tooltip positioning
    function calculateTooltipPosition(tooltipText) {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const tooltipWidth = tooltipText.offsetWidth;
        const tooltipHeight = tooltipText.offsetHeight;
        // Center the tooltip
        const left = Math.max(0, (viewportWidth - tooltipWidth) / 2);
        const top = Math.max(0, (viewportHeight - tooltipHeight) / 2);
        return {
            left: left,
            top: top
        };
    }
    // Debounced position calculation
    const debouncedCalculatePosition = debounce(calculateTooltipPosition, 16); // ~60fps
    document.querySelectorAll('.tooltip-icon').forEach(function(tooltipIcon) {
        tooltipIcon.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default behavior
            event.stopPropagation(); // Prevent the click from bubbling up to the document
            var tooltipText = this.querySelector('.tooltip-text');
            if (!tooltipText) return; // Exit if no tooltip found
            // If the clicked tooltip is already active, hide it
            if (activeTooltip === tooltipText) {
                hideTooltip(tooltipText);
                return; // Exit the function
            }
            // Hide the previously active tooltip if it exists
            if (activeTooltip) hideTooltip(activeTooltip);
            // Store original parent if not already stored
            if (!originalParents.has(tooltipText)) originalParents.set(tooltipText, tooltipText.parentNode);
            // Move tooltip to body if it's not already there
            if (tooltipText.parentNode !== document.body) document.body.appendChild(tooltipText);
            // Show the new tooltip and overlay
            showTooltip(tooltipText);
        }, {
            passive: false
        }); // Changed to false to allow preventDefault
    });
    // Close tooltip when clicking outside - use passive listener
    document.addEventListener('click', function(event) {
        if (activeTooltip) {
            const tooltipText = activeTooltip;
            const tooltipIcon = document.querySelector(`.tooltip-icon:has(.tooltip-text[style*="display: block"])`);
            // Only close if clicking outside both the tooltip and its icon
            if (!tooltipText.contains(event.target) && !tooltipIcon?.contains(event.target)) hideTooltip(tooltipText);
        }
    }, {
        passive: true
    });
    // Close tooltip when clicking the close button
    document.querySelectorAll('.close-tooltip').forEach(function(closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.stopPropagation(); // Prevent the click from bubbling up to the document
            var tooltipText = this.closest('.tooltip-text');
            if (tooltipText) hideTooltip(tooltipText);
        }, {
            passive: true
        }); // Mark as passive
    });
    // Add click event listener to tooltip text to prevent closing
    document.querySelectorAll('.tooltip-text').forEach(function(tooltipText) {
        tooltipText.addEventListener('click', function(event) {
            event.stopPropagation(); // Prevent the click from bubbling up to the document
        }, {
            passive: true
        });
    });
    // Function to show tooltip - optimized with requestAnimationFrame
    function showTooltip(tooltipText) {
        if (!tooltipText || !overlay) return;
        requestAnimationFrame(()=>{
            tooltipText.style.display = 'block';
            overlay.style.display = 'block';
            activeTooltip = tooltipText;
            document.body.classList.add('modal-open');
            // Calculate position
            const { left: left, top: top } = calculateTooltipPosition(tooltipText);
            tooltipText.style.left = `${left}px`;
            tooltipText.style.top = `${top}px`;
        });
    }
    // Function to hide tooltip - optimized with requestAnimationFrame
    function hideTooltip(tooltipText) {
        if (!tooltipText || !overlay) return;
        requestAnimationFrame(()=>{
            tooltipText.style.display = 'none';
            overlay.style.display = 'none';
            activeTooltip = null;
            document.body.classList.remove('modal-open');
            // Move tooltip back to its original parent
            const originalParent = originalParents.get(tooltipText);
            if (originalParent && tooltipText.parentNode === document.body) originalParent.appendChild(tooltipText);
        });
    }
    // Optimize resize handling for tooltip positioning
    const debouncedResizeHandler = debounce(()=>{
        if (activeTooltip) {
            const { left: left, top: top } = calculateTooltipPosition(activeTooltip);
            activeTooltip.style.left = `${left}px`;
            activeTooltip.style.top = `${top}px`;
        }
    }, 100);
    window.addEventListener('resize', debouncedResizeHandler, {
        passive: true
    });
});


//# sourceMappingURL=naspi.52628959.js.map
